<template>
    <insurance-company-sex-analyze-bar-chart/>
</template>
<script>
//import InsuranceCompanySexAnalyzePieChart from '../../components/charts/InsuranceCompanySexAnalyzePieChart.vue';
import InsuranceCompanySexAnalyzeBarChart from '../../components/charts/InsuranceCompanySexAnalyzeBarChart.vue';
export default {
    components:{
        //InsuranceCompanySexAnalyzePieChart
        InsuranceCompanySexAnalyzeBarChart
    }
};
</script>
<style scoped>

</style>